import { createGlobalStyle } from 'styled-components';
import { MOBILE_BREAKPOINT, convertToVwMob } from '../Utils/responsive';

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    font-family: ${({ theme }) => theme.typography.family};
    background: ${({ theme }) => theme.colors.other.mainBackground};
    color: ${({ theme }) => theme.colors.grayScale[80]};
    line-height: 1.5;
  }

  /* Mobile: use vw-based sizing (393px 기준) */
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    body {
      font-size: ${convertToVwMob(14)};
    }
  }

  h1, h2, h3, h4, h5, h6, p {
    margin: 0;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  button {
    font-family: ${({ theme }) => theme.typography.family};
  }
`;

export default GlobalStyle;

